import { api } from './client';

export interface BudgetContactDto {
  id: string;
  budgetId: string;
  budgetNumber: string;
  rootBudgetId: string;
  contactTypeId: string;
  contactTypeName: string;
  triggersRejection: boolean;
  isNoAnswer: boolean;
  notes: string | null;
  scheduledAt: string | null;
  createdById: string;
  createdByName: string | null;
  createdAt: string;
}

export interface FollowUpBudgetDto {
  id: string;
  budgetNumber: string;
  version: number;
  patientId: string;
  patientName: string;
  patientPhone: string;
  patientEmail: string;
  treatmentName: string | null;
  total: number;
  sentAt: string | null;
  contactCount: number;
  lastContactAt: string | null;
  nextScheduledAt: string | null;
  nextScheduledOverdue: boolean;
  lastContact: BudgetContactDto | null;
}

export interface CreateBudgetContactRequest {
  contactTypeId: string;
  notes?: string;
  scheduledAt?: string;
  rejectionTypeId?: string;
  rejectionNotes?: string;
}

export const budgetContactsApi = {
  getFollowUp: (): Promise<FollowUpBudgetDto[]> =>
    api.get('/budget-contacts/follow-up'),

  getContacts: (budgetId: string): Promise<BudgetContactDto[]> =>
    api.get(`/budget-contacts/${budgetId}/contacts`),

  createContact: (budgetId: string, data: CreateBudgetContactRequest): Promise<BudgetContactDto> =>
    api.post(`/budget-contacts/${budgetId}/contacts`, data),

  /**
   * Histórico agregado de contactos de TODOS los presupuestos del paciente
   * en el centro activo.
   */
  getByPatient: (patientId: string): Promise<BudgetContactDto[]> =>
    api.get(`/budget-contacts/by-patient/${patientId}`),
};
